/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0BinaryConstructionDayReportContentIdGet$Json } from '../fn/binary/api-v-0-binary-construction-day-report-content-id-get-json';
import { ApiV0BinaryConstructionDayReportContentIdGet$Json$Params } from '../fn/binary/api-v-0-binary-construction-day-report-content-id-get-json';
import { apiV0BinaryConstructionDayReportContentIdGet$Plain } from '../fn/binary/api-v-0-binary-construction-day-report-content-id-get-plain';
import { ApiV0BinaryConstructionDayReportContentIdGet$Plain$Params } from '../fn/binary/api-v-0-binary-construction-day-report-content-id-get-plain';
import { apiV0BinaryDocumentContentIdGet$Json } from '../fn/binary/api-v-0-binary-document-content-id-get-json';
import { ApiV0BinaryDocumentContentIdGet$Json$Params } from '../fn/binary/api-v-0-binary-document-content-id-get-json';
import { apiV0BinaryDocumentContentIdGet$Plain } from '../fn/binary/api-v-0-binary-document-content-id-get-plain';
import { ApiV0BinaryDocumentContentIdGet$Plain$Params } from '../fn/binary/api-v-0-binary-document-content-id-get-plain';
import { apiV0BinaryDocumentPreviewImageIdGet$Json } from '../fn/binary/api-v-0-binary-document-preview-image-id-get-json';
import { ApiV0BinaryDocumentPreviewImageIdGet$Json$Params } from '../fn/binary/api-v-0-binary-document-preview-image-id-get-json';
import { apiV0BinaryDocumentPreviewImageIdGet$Plain } from '../fn/binary/api-v-0-binary-document-preview-image-id-get-plain';
import { ApiV0BinaryDocumentPreviewImageIdGet$Plain$Params } from '../fn/binary/api-v-0-binary-document-preview-image-id-get-plain';
import { apiV0BinaryHourOverviewContentPost$Json } from '../fn/binary/api-v-0-binary-hour-overview-content-post-json';
import { ApiV0BinaryHourOverviewContentPost$Json$Params } from '../fn/binary/api-v-0-binary-hour-overview-content-post-json';
import { apiV0BinaryHourOverviewContentPost$Plain } from '../fn/binary/api-v-0-binary-hour-overview-content-post-plain';
import { ApiV0BinaryHourOverviewContentPost$Plain$Params } from '../fn/binary/api-v-0-binary-hour-overview-content-post-plain';
import { apiV0BinaryHourOverviewExportPost$Json } from '../fn/binary/api-v-0-binary-hour-overview-export-post-json';
import { ApiV0BinaryHourOverviewExportPost$Json$Params } from '../fn/binary/api-v-0-binary-hour-overview-export-post-json';
import { apiV0BinaryHourOverviewExportPost$Plain } from '../fn/binary/api-v-0-binary-hour-overview-export-post-plain';
import { ApiV0BinaryHourOverviewExportPost$Plain$Params } from '../fn/binary/api-v-0-binary-hour-overview-export-post-plain';
import { apiV0BinaryInspectionContentGet$Json } from '../fn/binary/api-v-0-binary-inspection-content-get-json';
import { ApiV0BinaryInspectionContentGet$Json$Params } from '../fn/binary/api-v-0-binary-inspection-content-get-json';
import { apiV0BinaryInspectionContentGet$Plain } from '../fn/binary/api-v-0-binary-inspection-content-get-plain';
import { ApiV0BinaryInspectionContentGet$Plain$Params } from '../fn/binary/api-v-0-binary-inspection-content-get-plain';
import { apiV0BinaryUploadDocumentsPost } from '../fn/binary/api-v-0-binary-upload-documents-post';
import { ApiV0BinaryUploadDocumentsPost$Params } from '../fn/binary/api-v-0-binary-upload-documents-post';

@Injectable({ providedIn: 'root' })
export class BinaryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0BinaryUploadDocumentsPost()` */
  static readonly ApiV0BinaryUploadDocumentsPostPath = '/api/v0/binary/uploadDocuments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryUploadDocumentsPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiV0BinaryUploadDocumentsPost$Response(params?: ApiV0BinaryUploadDocumentsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0BinaryUploadDocumentsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryUploadDocumentsPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiV0BinaryUploadDocumentsPost(params?: ApiV0BinaryUploadDocumentsPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0BinaryUploadDocumentsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryDocumentContentIdGet()` */
  static readonly ApiV0BinaryDocumentContentIdGetPath = '/api/v0/binary/document/content/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryDocumentContentIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentContentIdGet$Plain$Response(params: ApiV0BinaryDocumentContentIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryDocumentContentIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryDocumentContentIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentContentIdGet$Plain(params: ApiV0BinaryDocumentContentIdGet$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryDocumentContentIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryDocumentContentIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentContentIdGet$Json$Response(params: ApiV0BinaryDocumentContentIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryDocumentContentIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryDocumentContentIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentContentIdGet$Json(params: ApiV0BinaryDocumentContentIdGet$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryDocumentContentIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryDocumentPreviewImageIdGet()` */
  static readonly ApiV0BinaryDocumentPreviewImageIdGetPath = '/api/v0/binary/document/previewImage/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryDocumentPreviewImageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentPreviewImageIdGet$Plain$Response(params: ApiV0BinaryDocumentPreviewImageIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryDocumentPreviewImageIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryDocumentPreviewImageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentPreviewImageIdGet$Plain(params: ApiV0BinaryDocumentPreviewImageIdGet$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryDocumentPreviewImageIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryDocumentPreviewImageIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentPreviewImageIdGet$Json$Response(params: ApiV0BinaryDocumentPreviewImageIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryDocumentPreviewImageIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryDocumentPreviewImageIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryDocumentPreviewImageIdGet$Json(params: ApiV0BinaryDocumentPreviewImageIdGet$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryDocumentPreviewImageIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryConstructionDayReportContentIdGet()` */
  static readonly ApiV0BinaryConstructionDayReportContentIdGetPath = '/api/v0/binary/construction-day-report/content/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryConstructionDayReportContentIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryConstructionDayReportContentIdGet$Plain$Response(params: ApiV0BinaryConstructionDayReportContentIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryConstructionDayReportContentIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryConstructionDayReportContentIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryConstructionDayReportContentIdGet$Plain(params: ApiV0BinaryConstructionDayReportContentIdGet$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryConstructionDayReportContentIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryConstructionDayReportContentIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryConstructionDayReportContentIdGet$Json$Response(params: ApiV0BinaryConstructionDayReportContentIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryConstructionDayReportContentIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryConstructionDayReportContentIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryConstructionDayReportContentIdGet$Json(params: ApiV0BinaryConstructionDayReportContentIdGet$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryConstructionDayReportContentIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryHourOverviewContentPost()` */
  static readonly ApiV0BinaryHourOverviewContentPostPath = '/api/v0/binary/hour-overview/content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryHourOverviewContentPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewContentPost$Plain$Response(params?: ApiV0BinaryHourOverviewContentPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryHourOverviewContentPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryHourOverviewContentPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewContentPost$Plain(params?: ApiV0BinaryHourOverviewContentPost$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryHourOverviewContentPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryHourOverviewContentPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewContentPost$Json$Response(params?: ApiV0BinaryHourOverviewContentPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryHourOverviewContentPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryHourOverviewContentPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewContentPost$Json(params?: ApiV0BinaryHourOverviewContentPost$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryHourOverviewContentPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryInspectionContentGet()` */
  static readonly ApiV0BinaryInspectionContentGetPath = '/api/v0/binary/inspection/content';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryInspectionContentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryInspectionContentGet$Plain$Response(params?: ApiV0BinaryInspectionContentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryInspectionContentGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryInspectionContentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryInspectionContentGet$Plain(params?: ApiV0BinaryInspectionContentGet$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryInspectionContentGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryInspectionContentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryInspectionContentGet$Json$Response(params?: ApiV0BinaryInspectionContentGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryInspectionContentGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryInspectionContentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0BinaryInspectionContentGet$Json(params?: ApiV0BinaryInspectionContentGet$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryInspectionContentGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV0BinaryHourOverviewExportPost()` */
  static readonly ApiV0BinaryHourOverviewExportPostPath = '/api/v0/binary/hour-overview/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryHourOverviewExportPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewExportPost$Plain$Response(params?: ApiV0BinaryHourOverviewExportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryHourOverviewExportPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryHourOverviewExportPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewExportPost$Plain(params?: ApiV0BinaryHourOverviewExportPost$Plain$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryHourOverviewExportPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0BinaryHourOverviewExportPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewExportPost$Json$Response(params?: ApiV0BinaryHourOverviewExportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV0BinaryHourOverviewExportPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0BinaryHourOverviewExportPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0BinaryHourOverviewExportPost$Json(params?: ApiV0BinaryHourOverviewExportPost$Json$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV0BinaryHourOverviewExportPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
